import styled from 'styled-components'

export const SectionTitle = styled.h2`
  font-family: ${props => props.theme.fonts.robotoRegular};
  color: ${props => props.theme.colors.primary};
  font-size: ${props => props.theme.fontSizes.section.sectionTitle};
  margin: 0;
`



// WEBPACK FOOTER //
// ./src/Components/Section/SectionTitle/index.js